import { service } from "./base";

export default {
  getMatchVersion() {
    return service.get("/sys/dict/data/get/caso_match_version");
  },
  // 报名
  setSign(data) {
    return service.post("/apply/info/add", data);
  },
  // 报名列表
  /**
   * 
   * @param {*} param0 
   * @returns keyword 关键字查询 模糊匹配 参赛学生, 指导老师, 学校名称
school 学校名称查询
status 审核状态 0 未审核 1通过 2驳回
schoolType 学校类型 0小学 1初中
address 联系地址 模糊查询
days 连续观测天数大于多少天
   */
  signList({
    pageNum,
    pageSize,
    keyword,
    userId,
    days,
    school,
    status,
    schoolType,
    address,
    matchVersion,
    havingPass,
  }) {
    // 将参数对象传递给 axios 的 params 字段
    return service.get("/apply/info/page", {
      params: {
        pageNum,
        pageSize,
        keyword,
        userId,
        days,
        school,
        status,
        schoolType,
        address,
        matchVersion,
        havingPass,
      },
    });
  },

  // 上报气象数据列表
  reportList(params) {
    return service.get("/apply/record/all/page", {
      params: {
        pageNum: params.pageNum,
        pageSize: params.pageSize,
        date: params.date,
        userId: params.userId,
        matchVersion: params.matchVersion,
      },
    });
  },

  // 上报气象数据
  reportData(data) {
    return service.post("/apply/record/all/save", data);
  },
  // 查询报名信息
  getSignDetail(id, version) {
    return service.get("/apply/info/oneByUserId", {
      params: { userId: id, matchVersion: version },
    });
  },

  // 查询设备列表
  getList(params) {
    // 将参数对象传递给 axios 的 params 字段
    return service.get("/connect/list/by/userName/v2", {
      params: {
        userName: params.userName,
        email: params.email,
        userId: params.userId,
      },
    });
  },

  // 自动获取数据
  getAutoData(params) {
    return service.get("/device_data/newest/v2", {
      params: {
        device: params.device,
        time: params.time,
      },
    });
  },
  // 上传乱问小报告
  reportLunwen(data, versioin) {
    return service.post("/apply/info/update", {
      ...data,
      matchVersion: versioin,
    });
  },

  // 统计记录天数
  days(id, version) {
    return service.get("/apply/record/all/stat", {
      params: { userId: id, matchVersion: version },
    });
  },

  // 评分
  review(data) {
    return service.post("/apply/score/add", data);
  },
  // 审核
  audit(data) {
    return service.post("/apply/info/update", data);
  },
  generateBindCode(id) {
    return service.get("/apply/info/bindCode", {
      params: { applyId: id },
    });
  },
  bindTeam(id, code) {
    return service.get("/apply/info/bind", {
      params: { userId: id, bindCode: code },
    });
  },
};
